export const iconFontAwesomeCampingFrog = (
	<i className="fa-solid fa-frog"></i>
);
